import { filter } from 'lodash';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import Banner from '../components/Banner';
import menuContext from '../contexts/menu';

export default () => {
  const { menuCache } = useContext(menuContext);
  const { fridgeId: selectedFridge } = useParams() || {};
  const { ads } = menuCache || {};
  const images = filter(((ads || {})[selectedFridge] || (ads || {}).default || '').split(','));

  return (
    <Banner images={images || []} />
  );
};
